type StaffRouteKey = 'operations' | 'finance' | 'mentor' | 'lecturer' | 'admin' | 'reports';

const STAFF_ROUTE_ROLES: Record<StaffRouteKey, string[]> = {
  operations: ['Operations', 'summer_operations'],
  finance: ['Finance', 'Accountant', 'summer_finance', 'Admin', 'summer_admin'],
  mentor: ['Mentor', 'summer_mentor'],
  lecturer: ['Lecturer', 'summer_lecturer'],
  admin: ['Admin', 'summer_admin'],
  reports: ['Reports', 'Quality Employee', 'summer_reports'],
};

const STAFF_HOME_ROUTES: Record<string, string> = {
  admin: '/summer-training/admin',
  summer_admin: '/summer-training/admin',
  operations: '/summer-training/operations',
  summer_operations: '/summer-training/operations',
  finance: '/summer-training/finance',
  accountant: '/summer-training/finance',
  summer_finance: '/summer-training/finance',
  mentor: '/summer-training/mentor',
  summer_mentor: '/summer-training/mentor',
  lecturer: '/summer-training/lecturer',
  summer_lecturer: '/summer-training/lecturer',
  reports: '/summer-training/reports',
  'quality employee': '/summer-training/reports',
  summer_reports: '/summer-training/reports',
};

type NavLink = {
  path: string;
  label: string;
  Icon: unknown;
};

export function normalizeSummerRole(role: unknown): string {
  return String(role || '').trim().toLowerCase();
}

export function isSummerStudent(role: unknown): boolean {
  return normalizeSummerRole(role) === 'student';
}

export function routeKeyFromPath(path: string): string {
  const match = String(path || '').match(/\/summer-training\/([^/?#]+)/);
  return match?.[1] || '';
}

export function canAccessStaffRoute(role: unknown, routeKey: string): boolean {
  const allowedRoles = STAFF_ROUTE_ROLES[routeKey as StaffRouteKey] || [];
  if (allowedRoles.length === 0) return false;
  const normalized = normalizeSummerRole(role);
  return allowedRoles.some((allowed) => normalizeSummerRole(allowed) === normalized);
}

export function homeRouteForSummerRole(role: unknown): string {
  if (isSummerStudent(role)) return '/summer-training/student/dashboard';
  return STAFF_HOME_ROUTES[normalizeSummerRole(role)] || '/summer-training/login';
}

export function staffLinksForRole<T extends NavLink>(role: unknown, links: T[]): T[] {
  if (isSummerStudent(role)) return [];
  return links.filter((link) => canAccessStaffRoute(role, routeKeyFromPath(link.path)));
}
